/// <amd-module name="Artifacts/Maven/MavenProtocol" />
import {
  createBadgeCommand,
  createDeleteCommand,
  createGetLinkCommand,
  createPermanentDeleteCommand,
  createPromoteCommand,
  createRestoreCommand,
  createUpstreamOverrideCommand,
} from "Artifacts/Maven/commands";
import { logoContributionId } from "Artifacts/Maven/components/Logo";
import { MavenAttributes } from "Artifacts/Maven/components/MavenPackageAttributes";
import { MavenOverview } from "Artifacts/Maven/components/MavenPackageOverview";
import { MavenModule } from "Artifacts/Maven/redux";
import { IFeedMavenDataService } from "Artifacts/Maven/services/MavenDataService";
import { Protocol } from "Artifacts/Root/Constants";
import { ProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import {
  ICommand,
  IProtocol,
  IProtocolOverviewProps,
  IUpstreamingProperties,
} from "Artifacts/Root/protocols/types";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { UpstreamVersionVisibility } from "Artifacts/Root/types/PackagingShared";
import * as React from "react";
import { IModuleTuple } from "redux-dynamic-modules";
import { IVssPageContext } from "VSS/Platform/Context";

export class MavenProtocol implements IProtocol {
  public readonly id = Protocol.Maven;
  public readonly name = "Maven";
  public readonly statusUrl = "https://status.maven.org/";

  public getCommands(
    pageContext: IVssPageContext,
    versions: IPackageVersionIdentity[],
    feed: IFeed,
  ): ICommand[] {
    const commands = [
      createPromoteCommand(pageContext, versions),
      createPermanentDeleteCommand(pageContext, versions, feed),
      createRestoreCommand(pageContext, versions),
      createDeleteCommand(pageContext, versions, feed),
      createBadgeCommand(pageContext, versions, feed),
      createUpstreamOverrideCommand(pageContext),
      createGetLinkCommand(pageContext, versions, feed),
    ].filter((x) => x !== undefined) as ICommand[];

    return commands;
  }

  public getLogoContributionId(): string {
    return logoContributionId;
  }

  public getOverviewComponent(): React.ComponentType<IProtocolOverviewProps> {
    return MavenOverview;
  }

  public getOverviewAttributesComponent(): React.ComponentType<IProtocolOverviewProps> {
    return MavenAttributes;
  }

  public getReduxModule(): IModuleTuple {
    return MavenModule;
  }

  public async getUpstreamOverrideStatus(
    pageContext: IVssPageContext,
    packageName: string,
    feed?: IFeed,
  ): Promise<boolean> {
    if (!feed) {
      return false;
    }
    const dataService = pageContext.getService<IFeedMavenDataService>("IFeedMavenDataService");
    const overrideBehavior = await dataService.getUpstreamingBehavior(
      feed?.id,
      packageName,
      feed?.project?.id,
    );
    return (
      overrideBehavior?.versionsFromExternalUpstreams ===
      UpstreamVersionVisibility.AllowExternalVersions
    );
  }

  public getUpstreamingProperties(_pageContext: IVssPageContext): IUpstreamingProperties {
    return {
      isPublicUpstreamsSupported: true,
      isCustomPublicUpstreamsSupported: false,
      isCollectionUpstreamsSupported: true,
      isAadUpstreamsSupported: true,
    };
  }

  public isProtocolEnabled(pageContext: IVssPageContext): boolean {
    return true;
  }
}

ProtocolService.registerProtocol(new MavenProtocol());
